export const totalLabel = {
    visible: !1,
    offset: 5,
    overlap: {
        clampForce: !0,
        strategy: []
    },
    smartInvert: !1,
    animation: !1,
    style: {
        fontSize: {
            type: "token",
            key: "l4FontSize"
        },
        fill: {
            type: "palette",
            key: "primaryFontColor"
        }
    }
};
//# sourceMappingURL=total-label.js.map
